export const getExpansionPanelMobileRule = (
  type: string,
  mediaMatch: boolean,
  expand: string | false,
  isEdit?: boolean,
) => {
  if (isEdit) return true;
  return !mediaMatch && expand && expand !== type ? false : true;
};
